import { render } from "./userList.vue?vue&type=template&id=83301aac"
import script from "./userList.vue?vue&type=script&lang=js"
export * from "./userList.vue?vue&type=script&lang=js"

import "./userList.vue?vue&type=style&index=0&id=83301aac&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__